import { useParams } from "react-router-dom";
import styles from "../../styles/Videos/video.module.css";
import VideoCategories from "../VideosComponents/VideoCategories";
import Videos from "../VideosComponents/Videos";

const IndividualVideo = () => {
  const { videoId } = useParams();
  console.log(videoId);

  return (
    <div id={styles.videoContainer}>
      <div className={styles.gradientLeft}></div>
      <div>
        <h1 id={styles.videoTitle}>Video Trainings</h1>
      </div>
      <div>
        <p id={styles.videoDesc}>
          Let’s Learn Something Extraordinary Together 
        </p>
      </div>

      <div id={styles.categoryAndVideosContainer}>
        <VideoCategories />
        <div>Current Video Will Play Here</div>
      </div>
      <Videos />
    </div>
  );
};

export default IndividualVideo;
